import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import CommonInputMask from "../../../components/forms/CommonInputMask";

function ConclusaoMigracaoModal({ modalHook, valuesHook, finalizarMigracao }) {
  const { values, setValues } = valuesHook;
  const { conclusaoMigracaoModal, setConclusaoMigracaoModal } = modalHook;

  return (
    <CommonModal
      title="Conclusão da abertura da empresa"
      is_open_modal={conclusaoMigracaoModal}
      set_is_open_modal={setConclusaoMigracaoModal}
      size="md"
      buttons={
        <CommonButton
          key={`novo-processo`}
          color="success"
          onClick={finalizarMigracao}
        >
          Adicionar empresa
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-lg-12 mb-3">
          <CommonInput
            label="Nome da Empresa"
            id="razao_social"
            value={values.razao_social}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
            disabled
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <CommonInputMask
            label="CNPJ"
            id="cnpj"
            value={values.cnpj}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="99.999.999/9999-99"
            required
            disabled
          />
        </div>
      </div>
    </CommonModal>
  );
}

ConclusaoMigracaoModal.propTypes = {
  modalHook: PropTypes.shape({
    conclusaoMigracaoModal: PropTypes.bool.isRequired,
    setConclusaoMigracaoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  finalizarMigracao: PropTypes.func.isRequired,
};

export default ConclusaoMigracaoModal;
